import { useHttpClient } from '@/common/api/httpClient';
import type { ReportServerConfig } from '../models/report';

export function useReportConfigApi() {
  return {
    execute,
  };

  async function execute() {
    const httpClient = useHttpClient();
    const headers = httpClient.defaultHeaders();

    const request = new Request(httpClient.siteUrl('report/config'), {
      method: 'GET',
      headers,
    });

    const response = await httpClient.execute(request);
    if (response.ok) {
      return (await response.json()) as ReportServerConfig;
    }

    const dummyConfig: ReportServerConfig = {
      reportUrl: '',
      authorization: '',
      filterValues: {},
    };
    return dummyConfig;
  }
}
